import { TableCellPerColumn } from "ds/components/TableSimple/types";

import { UsedByRow } from "../helpers";
import { USED_BY_COLUMN_ID } from "../constants";
import IntegrationsAwsUsedByTableDropdownCell from "./DropdownCell";
import IntegrationsAwsUsedByTableNameCell from "./NameCell";
import IntegrationsAwsUsedByTableSpaceCell from "./SpaceCell";
import IntegrationsAwsUsedByTableTypeCell from "./TypeCell";

export const INTEGRATIONS_AWS_USED_BY_TABLE_CELLS: TableCellPerColumn<UsedByRow> = {
  [USED_BY_COLUMN_ID.TYPE]: IntegrationsAwsUsedByTableTypeCell,
  [USED_BY_COLUMN_ID.NAME]: IntegrationsAwsUsedByTableNameCell,
  [USED_BY_COLUMN_ID.SPACE]: IntegrationsAwsUsedByTableSpaceCell,
  [USED_BY_COLUMN_ID.DROPDOWN]: IntegrationsAwsUsedByTableDropdownCell,
};
